module.exports = __webpack_public_path__ + "img/img2.037b08cf.jpg";